import PipeCard from "../../../pipe-common/PipeCard";
import React from "react";
import Terranova75XAPumpReadBack from "./common/Terranova75XAPumpReadBack";

export default function Terranova751AReadBack({pipe, data}) {
    return (
        <PipeCard
            title={pipe.title}
            status={"INACTIVE"}
            content={
                <Terranova75XAPumpReadBack data={data}/>
            }
        />
    );
}